// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__KwV_0","icon":"style_icon__fhqSR","title":"style_title__IijIn"};